import { z } from 'zod/v4';

export const LandingPageSettingsRuntype = z.object({
    enable_landing_page_logged_in: z.boolean(),
    enable_landing_page_anonymous: z.boolean(),
    background_color: z.string().nullable(),
    logo_url: z.string().nullable(),
});
export type LandingPageSettings = z.infer<typeof LandingPageSettingsRuntype>;

export const LandingPageSettingsUpdateRuntype = z.object({
    enable_landing_page_logged_in: z.boolean().optional(),
    enable_landing_page_anonymous: z.boolean().optional(),
    background_color: z.string().nullable().optional(),
    logo_url: z.string().nullable().optional(),
});
export type LandingPageSettingsUpdate = z.infer<typeof LandingPageSettingsUpdateRuntype>;

export const LandingPageTileRuntype = z.object({
    id: z.string(),
    title: z.string(),
    blurb: z.string().nullable(),
    image_url: z.string().nullable(),
    url: z.string(),
    signup_url: z.string().nullable(),
    is_visible_to_customers: z.boolean(),
    rank: z.number(),
});
export type LandingPageTile = z.infer<typeof LandingPageTileRuntype>;

export const LandingPageTileInsertRuntype = z.object({
    title: z.string(),
    blurb: z.string().nullable(),
    image_url: z.string().nullable(),
    url: z.string(),
    signup_url: z.string().nullable(),
    is_visible_to_customers: z.boolean(),
    rank: z.number(),
});
export type LandingPageTileInsert = z.infer<typeof LandingPageTileInsertRuntype>;

export const LandingPageTilesResponseRuntype = z.object({
    tiles: z.array(LandingPageTileRuntype),
});
export type LandingPageTilesResponse = z.infer<typeof LandingPageTilesResponseRuntype>;

export const PublicLandingPageResponseRuntype = z.object({
    tiles: z.array(LandingPageTileRuntype),
    settings: LandingPageSettingsRuntype,
});
export type PublicLandingPageResponse = z.infer<typeof PublicLandingPageResponseRuntype>;
